export default function ProblemsSection() {
  const problems = [
    {
      title: 'ブランクが心配',
      description: '育児や家庭の事情で介護を離れてしまい、技術や知識が追いついているか不安...',
      image: 'https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/e50b36bb4aafbf9d4e3e3e7689f6d574.png',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-100'
    },
    {
      title: 'フルタイムは難しい',
      description: '仕事とプライベートと両立したいから、週3日程度で働ける職場を探している...',
      image: 'https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/86546cfc5a06ed11045bf3ce448b3616.png',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-100'
    },
    {
      title: '時給に不満',
      description: '専門性のある仕事なのに、時給が低くてモチベーションが上がらない...',
      image: 'https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/8561eea589114d563a42b420313369c0.png',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-100'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            こんなお悩みありませんか?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600">
            介護の仕事に戻りたいけれど、不安や心配がある方へ
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className={`${problem.bgColor} p-6 sm:p-8 rounded-2xl border ${problem.borderColor}`}
            >
              <div className="flex items-start gap-4 sm:gap-6">
                <img 
                  src={problem.image}
                  alt={problem.title}
                  className="w-20 h-20 sm:w-24 sm:h-24 object-cover flex-shrink-0"
                />
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                    {problem.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    {problem.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}